import React from 'react';
import Head from 'next/head';
import { BootstrapLoadingWrapper } from 'components/BootstrapLoadingWrapper';
import { PricingScreen } from 'screens/Pricing/PricingScreen';
import { redirectAuthenticatedUser } from 'utils/pageUtils';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = redirectAuthenticatedUser;

export default function Pricing() {
  return (
    <>
      <Head>
        <title>{'Hevy - Pricing'}</title>
        <meta name="description" content={'Track workouts, make progress'} />
      </Head>
      <BootstrapLoadingWrapper>
        <PricingScreen />
      </BootstrapLoadingWrapper>
    </>
  );
}
